module.exports = __webpack_public_path__ + "img/offerNull.e55dcec1.png";